module.exports = __webpack_public_path__ + "static/media/img-home-mainVisual--pc@2x.710af242.jpg";